import { useContext, type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import ArrowRight from 'dibs-icons/exports/legacy/ArrowRight';
import Storefront from 'dibs-icons/exports/legacy/Storefront';
import SellerFormContext from './SellerFormContext';
import TagEmpty from 'dibs-icons/exports/legacy/TagEmpty';
import AccountOutlined from 'dibs-icons/exports/legacy/AccountOutlined';
import { trackSellerApplicationEvent } from '../helpers/sellerApplicationTracking';

import styles from './styles/SellerApplicationFormUserSelection.scss';

const UserTypeSelectionStep: FC = () => {
    const { dispatch } = useContext(SellerFormContext);
    const handleBusinessFormStart = (): void => {
        trackSellerApplicationEvent({
            type: 'professional',
            action: 'entry',
            interactionName: 'application_entry',
            stepInteractionType: 'click on professional seller/gallery',
        });
        dispatch({ type: 'SET_STEP', step: 'BUSINESS_INTRO' });
    };
    const handleConsignorFormStart = (): void => {
        trackSellerApplicationEvent({
            type: 'individual',
            action: 'entry',
            interactionName: 'application_entry',
            stepInteractionType: 'click on individual',
        });
        dispatch({ type: 'SET_STEP', step: 'CONSIGNORS_RESTRICTION_MESSAGE' });
    };

    return (
        <div className={styles.linksWrapper}>
            <Link onClick={handleBusinessFormStart} className={styles.link}>
                <Storefront className={styles.storeFront} />
                <span className={styles.text}>
                    <FormattedMessage
                        id="NewDealerApplicationForm.businessStep"
                        defaultMessage="I'm a professional seller or gallery"
                    />
                </span>
                <ArrowRight className={styles.arrow} />
            </Link>
            <Link onClick={handleConsignorFormStart} className={styles.link}>
                <div className={styles.consignorsIcon}>
                    <AccountOutlined className={styles.accountOutlined} />
                    <TagEmpty className={styles.tag} />
                </div>
                <span className={styles.text}>
                    <FormattedMessage
                        id="NewDealerApplicationForm.consignorsStep"
                        defaultMessage="I'm an individual looking to sell a few items"
                    />
                </span>
                <ArrowRight className={styles.arrow} />
            </Link>
        </div>
    );
};

export default UserTypeSelectionStep;
